<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Add Maintenance Record
          </v-card-title>
          <v-card-text>
              <equipment-selector v-model="equip"></equipment-selector>
              <v-text-field label="Fault" autofocus v-model="label"></v-text-field>
              <date-range-selector v-model="range"></date-range-selector>
              <v-textarea label="Description" v-model="description">
              </v-textarea>
              <severity-selector v-model="severity" label="Severity"></severity-selector>
              <v-text-field label="Reference URL" v-model="url"></v-text-field>
              <v-checkbox v-model="isFixed" label="Fixed?"></v-checkbox>
              <v-select
                      :items="userNames"
                      label="Assigned to"
                      v-model="assigned_to"
              ></v-select>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord()" :disabled="!$can('update', 'MaintenanceRecord')">Save</v-btn>
              <v-btn @click="dialog=false">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import DateRangeSelector from './DateRangeSelector'
  import EquipmentSelector from './EquipmentSelector'
  import SeveritySelector from "./SeveritySelector";
  import {putMaintenanceRecord,getUser} from '../helper'

  export default {
    components: { EquipmentSelector, DateRangeSelector ,SeveritySelector},
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.facility_name = item['facility_name']
          this.equip= item['equipment']
          this.range = {start: item['maintenance_date_from'], end: item['maintenance_date_to']}
          this.description = item['maintenance_text']
          this.label = item['maintenance_label']
          this.url = item['url']
            if(item['severity']){
                this.severity = item['severity']
            }
          this.isFixed = item['is_fixed']
          this.maintenance_id = item['maintenance_id']
          this.assigned_to = item['assigned_to']
          this.notification_id = item['notification_id']
        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        equip: null,
        isFixed: false,
        range: null,
        label: '',
          severity: 'low',
        description: '',
        url: '',
          userNames:[],
          assigned_to:null,
        maintenance_id: null,
        notification_id: null
      }
    },
    methods: {
      initializeVar() {
        this.equip= null
        this.isFixed= false
        this.assigned_to= null
        this.label= ''
        this.description=''
        this.url= ''
        this.maintenance_id = null
      },
      async addRecord () {
          await putMaintenanceRecord(
              {
                  'maintenance_id': this.maintenance_id,
                  'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'equipment_name': this.equip,
                  'maintenance_date_from': this.range.start,
                  'maintenance_date_to': this.range.end,
                  'maintenance_text': this.description,
                  'maintenance_label': this.label,
                  'assigned_to': this.assigned_to,
                  'url': this.url,
                  'severity': this.severity,
                  'notification_id': this.notification_id,
                  'is_fixed': this.isFixed
              }
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'FaultRecordDialog',
      async beforeMount() {
          let df = await getUser({
          })
          this.userNames=df.users.map(x=>x.user_name)
      }
  }
</script>

<style scoped>

</style>
